import classnames from 'classnames';
import * as cssUtils from '../../utils/css-utils';
import { isFooterHidden } from '../get-footer';
export function getAdSection(_a) {
    var css = _a.css, lpProps = _a.lpProps, composerData = _a.composerData;
    if (lpProps.showAd === true) {
        var rules = [css['so-global-region-footer'], css['so-global-region']];
        var mobileCssClass = cssUtils.getRegionMobileCssClass(rules);
        var bottomCss = cssUtils.getBottomPaddingRestrictionCssClass(rules);
        var margin = cssUtils.margin(rules);
        var padding = cssUtils.padding(rules);
        var footerHidden = isFooterHidden(composerData);
        margin.top = footerHidden ? 15 : 0;
        padding.top = 0;
        return {
            cssClass: classnames(mobileCssClass, bottomCss),
            outerPadding: margin,
            innerPadding: padding,
        };
    }
    return null;
}
//# sourceMappingURL=get-ad-section.js.map